import React from "react";
import AreaChart from "../../charts/AreaChart";
import PieChart from "../../charts/PieChart";
import Searchbar from "./components/Searchbar";
import MusicLoader from "./components/MusicLoader";
import StarIcon from '../../../../assets/images/icons/start-icon.svg';
import 'flag-icons/css/flag-icons.min.css'
import ReactCountryFlag from "react-country-flag";
import DummyChart from "../../../../components/DummyChart";
import { PieChartSkeleton } from "../../CommonSkeleton";
import CountryFlag from "../../../../components/CountryFlag";

function PageContent(props) {
  const {
    buttonWithIcon,
    withSearch,
    buttonLabel,
    searchPlaceholder,
    periodOptions = [],
    selectedPeriod = "",
    onPeriodChange = () => { },
    onPlatformsChange = () => { },
    selectedPlatform = "",
    platforms = [],
    onButtonClick = () => { },
    onProClick = () => { },
    metrics = [],
    setTrack = () => { },
    forArtist,
    isLoading,
    isMarginBottom,
    greyedOutButton,
    hasActiveSubscription
  } = props || {};
  const handleSelectTrack = (e) => {
    setTrack(e);
  };
  const openTrack = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };
  console.log('metrics', metrics)

  return (
    <div className={`performance-section bg-theme_clr1 rounded-xl ${isMarginBottom ? "mb-5" : ''} p-4 lg:px-5 pt-[26px] pb-[30px]`}>
      <div className="header-section flex flex-wrap items-center justify-between gap-2 mb-[10px] md:mb-[21px]">
        <div className="flex flex-wrap gap-6">
          <div className="relative">
            <select
              className="appearance-none bg-theme_clr1 text-white text-base font-manrope border-0 focus:outline-none pr-8"
              value={selectedPeriod}
              onChange={onPeriodChange}
              style={{
                WebkitAppearance: "none",
                MozAppearance: "none",
                appearance: "none",
              }}
            >
              {periodOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {platforms.length > 0 ? (
            <div className="icons flex items-center gap-6">
              {platforms.map((platform) => (

                <img
                  key={platform.alt}
                  src={platform.icon}
                  alt={platform.alt}
                  onClick={() => onPlatformsChange(platform.name)}
                  className={`block w-[30px] h-[30px] cursor-pointer ${selectedPlatform === platform.name
                    ? "ring-4 ring-orange-500 squared-full rounded"
                    : ""
                    }`}
                />
              ))}
            </div>
          ) : withSearch ? (
            <Searchbar
              searchPlaceholder={searchPlaceholder}
              fetchTrackStats
              period={selectedPeriod}
              isArtistData={forArtist}
              onSelectTrack={handleSelectTrack}
              source={selectedPlatform}
            />
          ) : (
            ""
          )}
        </div>
        {withSearch && platforms.length > 0 && (
          <Searchbar
            searchPlaceholder={searchPlaceholder}
            fetchTrackStats
            period={selectedPeriod}
            onSelectTrack={handleSelectTrack}
            isArtistData={forArtist}
          />
        )}
        {buttonLabel && (
          <button type="button" className={`btn-custom3 ${greyedOutButton ? 'opacity-50' : ''}`} onClick={onButtonClick}>
            {buttonLabel}
            {buttonWithIcon && (
              <i className="bi bi-plus-circle inline-block ml-2 w-4 h-4"></i>
            )}
          </button>
        )}
      </div>
      <div
        className={`grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-${metrics?.length} gap-4 2xl:gap-[22px] flex-nowrap overflow-auto`}
      >
        {metrics.map((metric, idx) => (
          <div
            className={`grid-item ${metric.colSpan ? metric.colSpan : ""}`}
            key={metric.label}
          >
            <div className="info-box h-full bg-white font-manrope flex flex-col justify-between gap-2 rounded-xl p-4 2xl:p-5">
              {hasActiveSubscription ?
                <>
                  <div className="icon mb-1">
                    <img src={metric.icon} alt={metric.label} />
                    {metric.trackName &&
                      (isLoading ? (
                        <div className="cover animate-pulse">
                          <div className="h-[14px] w-[60px] bg-blue-300 rounded" />
                        </div>
                      ) : (
                        <div className="text-black text-[12.26px] font-bold mt-2">
                          {metric.trackName}
                        </div>
                      ))
                    }
                  </div>
                  <div className="chart-wrapper" style={metric.chartStyle}>
                    {isLoading ? (
                      metric?.chartData?.type === "pie" ? (
                        <PieChartSkeleton />
                      ) : (
                        <MusicLoader />
                      )
                    ) : metric.image ? (
                      <img
                        onClick={() => openTrack(metric.url)}
                        src={metric.image}
                        alt={metric.label}
                        className="block w-[200px] mx-auto cursor-pointer"
                      />
                    ) : metric?.chartData?.type === "pie" ? (
                      <PieChart chartData={metric.chartData} />
                    ) : metric?.chartData?.data?.length === 0 ? (
                      <div className="info font-3vw font-semibold leading-tight text-center text-theme_clr1 mb-[17px]">
                        {metric.score || "0"}
                      </div>
                    ) : metric.flag ? (
                      <div className="flag-wrapper">
                        <CountryFlag
                          city={metric.flag || ''}
                          countryCode={metric.flag || ''}
                          showName={false}
                        />
                        {/* <ReactCountryFlag
                          countryCode={metric.flag}
                          svg
                          style={{ width: "4em", height: "4em" }}
                        /> */}
                      </div>
                    ) : (
                      <AreaChart key={selectedPeriod} state={metric.chartData} />
                    )}
                  </div>
                  {isLoading ? (
                    <div className="cover animate-pulse">
                      <div className="h-[14px] w-[40px] bg-blue-300 rounded mb-[2px]" />
                      <div className="h-[14px] w-[60px] bg-blue-300 rounded" />
                    </div>
                  ) : (
                    <div className="cover">
                      <div className="text-theme_clr1 text-[12.26px] font-bold mb-[2px]">
                        {metric.value}
                      </div>
                      <div className="text-theme_clr1 text-[12.8px]">
                        {metric.label}
                      </div>
                    </div>
                  )}
                </>
                :
                <DummyChart
                  icon={metric.icon}
                  chartType={metric.label === "Best Performing Track" ? "image" : "area"}
                  topText="254k"
                  bottomText={metric.label}
                  onProClick={onProClick}
                />
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default PageContent;
